import { dew as _feeDew } from "../../errors/fee.js";
import { dew as _fromHexDew } from "../../utils/encoding/fromHex.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _getBlockDew } from "./getBlock.js";
import { dew as _getGasPriceDew } from "./getGasPrice.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.internal_estimateMaxPriorityFeePerGas = exports.estimateMaxPriorityFeePerGas = void 0;
  const fee_js_1 = _feeDew();
  const fromHex_js_1 = _fromHexDew();
  const getAction_js_1 = _getActionDew();
  const getBlock_js_1 = _getBlockDew();
  const getGasPrice_js_1 = _getGasPriceDew();
  async function estimateMaxPriorityFeePerGas(client, args) {
    return internal_estimateMaxPriorityFeePerGas(client, args);
  }
  exports.estimateMaxPriorityFeePerGas = estimateMaxPriorityFeePerGas;
  async function internal_estimateMaxPriorityFeePerGas(client, args) {
    const {
      block: block_,
      chain = client.chain,
      request
    } = args || {};
    if (typeof chain?.fees?.defaultPriorityFee === "function") {
      const block = block_ || (await (0, getAction_js_1.getAction)(client, getBlock_js_1.getBlock, "getBlock")({}));
      return chain.fees.defaultPriorityFee({
        block,
        client,
        request
      });
    }
    if (typeof chain?.fees?.defaultPriorityFee !== "undefined") return chain?.fees?.defaultPriorityFee;
    try {
      const maxPriorityFeePerGasHex = await client.request({
        method: "eth_maxPriorityFeePerGas"
      });
      return (0, fromHex_js_1.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch {
      const [block, gasPrice] = await Promise.all([block_ ? Promise.resolve(block_) : (0, getAction_js_1.getAction)(client, getBlock_js_1.getBlock, "getBlock")({}), (0, getAction_js_1.getAction)(client, getGasPrice_js_1.getGasPrice, "getGasPrice")({})]);
      if (typeof block.baseFeePerGas !== "bigint") throw new fee_js_1.Eip1559FeesNotSupportedError();
      const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
      if (maxPriorityFeePerGas < 0n) return 0n;
      return maxPriorityFeePerGas;
    }
  }
  exports.internal_estimateMaxPriorityFeePerGas = internal_estimateMaxPriorityFeePerGas;
  //# sourceMappingURL=estimateMaxPriorityFeePerGas.js.map
  return exports;
}